import React, { FC, useEffect, useMemo, useReducer } from 'react';
import StudentAssignmentsSection from './StudentAssignmentsSection';
import { Filter } from '../../../shared/components';
import apiRoutes from '../../../../config/api/routes';
import { useFetch } from '../../../shared/hooks';
import { FilterOption } from '../../../shared/components/Filter';
import { useTranslation } from 'react-i18next';
import { StyledBookFilter } from './Atoms';
import { IUserBook } from 'src/config/api/models/Book';

export type AssignmentSections = 'todo' | 'done';

const StudentAssignments: FC = () => {
  const { t } = useTranslation();

  const [selectedSection, setSelectedSection] = useReducer((oldValue: any, newValue: any) => {
    if (newValue === oldValue) return undefined;
    return newValue;
  }, 'todo');

  const [{ bookFilter }, patchFilters] = useReducer(
    (state: { [key: string]: string }, patch: { [key: string]: string }) => {
      if (patch.bookFilter === '') return { bookFilter: '' };
      return { ...state, ...patch };
    },
    { bookFilter: '' }
  );

  const [booksResponse, getBooks] = useFetch<IUserBook[]>(apiRoutes.booksByUser());

  useEffect(getBooks, [getBooks]);

  const subjects: FilterOption[] = useMemo(() => {
    if (!booksResponse.success) return [];

    return booksResponse.data.map(({ id, title }) => ({ id, label: title }));
  }, [booksResponse]);

  return (
    <div style={{ paddingTop: '1rem' }}>
      <StyledBookFilter>
        <Filter
          id="book-filter"
          label={'filter vak'}
          value={bookFilter}
          onChange={(bookFilter) => patchFilters({ bookFilter })}
          placeholder={t('shared.forms.allSubjects')}
          options={subjects}
          emptyOption
        />
      </StyledBookFilter>

      <StudentAssignmentsSection
        section="todo"
        open={selectedSection === 'todo'}
        onToggle={setSelectedSection}
        bookFilter={bookFilter}
      />

      <StudentAssignmentsSection
        section="done"
        open={selectedSection === 'done'}
        onToggle={setSelectedSection}
        bookFilter={bookFilter}
      />
    </div>
  );
};

export default StudentAssignments;
